import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

const useUnauthorizedHandler = () => {
  const navigate = useNavigate();

  const handleUnauthorizedAccess = useCallback(() => {
    // localStorage.clear();
    // 
    const keysToRemove = [ // added this for remove auth screen
      "conserve_authtoken",
      "LoginUserData",
      "currentPath",
      "login",
      "permission_data",
      "permissionData",
      "rememberPassword",
      "rememberUser",
      "remember30Days",
      "two_factor_auth",
      "rememberEmail"
    ];

    // Use a Set to ensure no duplicate keys are removed redundantly
    localStorage.setItem("checkAuth", JSON.stringify(""));
    new Set(keysToRemove).forEach(key => localStorage.removeItem(key));
    localStorage.setItem("Conserve_http_Authenticated", "true");  // added this for remove auth screen
    navigate('/Login');
  }, [navigate]);

  return handleUnauthorizedAccess;
};

export default useUnauthorizedHandler;
